// Team data was previously rendered on the Home page with individual lawyer
// names. Per current legal/branding guidance, individual lawyer names are no
// longer surfaced anywhere on the site. The TEAM array is intentionally empty
// so any accidental import continues to compile while rendering nothing.
export const TEAM = [];

export function getInitials(fullName) {
  if (!fullName) return "";
  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
